import { createFileRoute } from '@tanstack/react-router'
import { PhoneNumbersPage } from '@/features/operations/phone-numbers'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/dids/')({
  component: PhoneNumbersPage,
  beforeLoad: requireRole(['admin']),
})
